const SCOPE_SUBSCRIPTION_KEY = Symbol('ScopeSubscriptionKey');

export default SCOPE_SUBSCRIPTION_KEY;
